
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBlowerOnHorizontal as ObiBlowerOnHorizontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-blower-on-horizontal.js';
 
 
 

 
 export const ObiBlowerOnHorizontal = createComponent({
   react: React,
   tagName: 'obi-blower-on-horizontal',
   elementClass: ObiBlowerOnHorizontalElement,
   events: {
     
   }
  });
 
 